/** Animated skeleton shimmer block. */
export function Skeleton({ className = '' }: { className?: string }) {
  return (
    <div
      className={`bg-[#1E2332] rounded-lg animate-pulse ${className}`}
      aria-hidden="true"
    />
  );
}

/** Skeleton for a blog list card. */
export function BlogCardSkeleton() {
  return (
    <div className="bg-[#141821] rounded-2xl overflow-hidden">
      <Skeleton className="w-full h-44 rounded-none" />
      <div className="p-4 space-y-2">
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-5 w-full" />
        <Skeleton className="h-5 w-3/4" />
        <Skeleton className="h-3 w-1/2 mt-1" />
      </div>
    </div>
  );
}

/** Skeleton for a post card in the feed. */
export function PostCardSkeleton() {
  return (
    <div className="bg-[#141821] rounded-2xl p-4 mb-3.5">
      <div className="flex items-center gap-3 mb-3">
        <Skeleton className="w-10 h-10 rounded-full" />
        <div className="flex-1 space-y-1.5">
          <Skeleton className="h-3.5 w-28" />
          <Skeleton className="h-3 w-20" />
        </div>
      </div>
      <Skeleton className="h-4 w-full mb-1.5" />
      <Skeleton className="h-4 w-4/5 mb-3" />
      <Skeleton className="w-full h-48 rounded-xl mb-3" />
      <div className="flex gap-5">
        <Skeleton className="h-5 w-12" />
        <Skeleton className="h-5 w-12" />
        <Skeleton className="h-5 w-8" />
      </div>
    </div>
  );
}

/** Generic full-page loading skeleton. */
export function PageSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div className="px-4 pt-4">
      {Array.from({ length: count }).map((_, i) => (
        <PostCardSkeleton key={i} />
      ))}
    </div>
  );
}
